import { useState, useEffect } from "react";
import cargandoCard from "../../components/cargando-card";
import SinAccesoCard from "../../components/sin-acceso-card";
import ModalConfirmar from "../../components/modal-confirmar";
import Grid from "../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../utils/const/estilos-const";
import { useHistory } from "react-router-dom";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { INT_TIPO_USUARIO_ADMINISTRADOR_WEB } from "../../utils/const/int-const";
import { crearNuevoChecklist, deshabilitarChecklist, obtenerListaChecklist } from "../../api/api-checklist";
// import { TRUE } from "../../utils/const/bool-const";
import { sharedNextPage } from "../../utils/shared-functions";
import ModalCrearChecklist from "../../components/modal-crear-checklist";
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from "../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../utils/const/string-const";
import { obtenerPermisos } from "../../api/api-permisos";
import { PAGE_ID } from "../../utils/const/pages-const";
import { TRUE } from "../../utils/const/bool-const";

export default function ChecklistScreen() {

    const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
    const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);

    const { t } = useTranslation();
    const headers = [
        { key: "acciones", title: t('column_acciones') },
        { key: "id", title: "ID", visible: false, },
        { key: "nombre", title: t('column_nombre'), visible: true, filter: true, editLabel: true, },
        { key: "idTipoChecklist", title: "idTipoChecklist", visible: false, filter: false, editLabel: false, },
        { key: "tipoChecklist", title: t('column_tipo_checklist'), visible: true, filter: true, editLabel: true, },
        { key: "manejoDefensivo", title: t('column_manejo_defensivo'), visible: false, filter: false, editLabel: false, },
        { key: "manejoDefensivoLabel", title: t('column_manejo_defensivo'), visible: true, filter: false, editLabel: false, },

        { key: "viaje", title: t('column_viaje'), visible: false, filter: false, editLabel: false, },
        { key: "viajeLabel", title: t('column_viaje'), visible: true, filter: false, editLabel: false, },

        { key: "nota", title: t('column_nota'), visible: true, filter: true, editLabel: true, },
        { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true },
    ];

    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [listaElementos, setListaElementos] = useState([]);
    const [elementoSelected, setElementoSelected] = useState(null);
    const [elemento, setElemento] = useState({});
    const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
    // const [permisos, setPermisos] = useState(null);
    const [modalCrearChecklistVisible, setModalCrearChecklistVisible] = useState(false);
    const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

    const [btnNuevo, setBtnNuevo] = useState(false);
    // const [btnModificar, setBtnModificar] = useState(false);
    // const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
    // const [btnFormulario, setBtnFormulario] = useState(false);
    // const [btnAlertas, setBtnAlertas] = useState(false);

    // const [permisos, setPermisos] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            /*let obj = {};
            obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
            obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
            obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
            let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
            let permiso = obtenerPermisos[0];
            setPermisos(permiso);
            */
            const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
            if (colorBase !== null) {
                setColorMain(colorBase);
            }

            let lista = [];
            lista = await obtenerListaChecklist();
            let permiso = null;
            if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                setBtnNuevo(true);
                setTieneAccesoAlModulo(true);
            }
            if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                const objEnviar = {
                    idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
                };
                const permisos = await obtenerPermisos(objEnviar);
                if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
                    permiso = permisos.data[0];
                    const permisosInfo = JSON.parse(permisos.data[0].permisos);
                    // console.log('permisosInfo');
                    // console.log(permisosInfo);
                    const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.MIS_CHECKLIST);
                    // console.log('permisosPage');
                    // console.log(permisosPage);
                    setTieneAccesoAlModulo(permisosPage.checked === true);
                }
            }
            agregarAccionesALista(lista, permiso);
            setCargandoPage(false);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    };

    const agregarAccionesALista = (lista, permiso) => {
        try {
            // console.log('agregarAccionesALista', lista);
            // console.log(permiso);
            // if (lista.length === 0) {
            //     setListaElementos(lista);
            // }
            let btnModificar = false;
            let btnDeshabilitar = false;
            let btnFormulario = false;
            let btnAlertas = false;
            let btnNuevo = false;
            let btnViaje = false;
            if (permiso !== null) {
                const parsePermisos = JSON.parse(permiso.permisos);
                const permisosMisChecklist = parsePermisos.find(e => e.value === PAGE_ID.MIS_CHECKLIST);
                if (permisosMisChecklist !== undefined) {
                    const acciones = permisosMisChecklist.acciones;
                    if (acciones !== undefined) {
                        const modificar = acciones.find(e => e.value === 'btn_modificar');
                        if (modificar !== undefined) {
                            btnModificar = modificar.checked;
                        }
                        const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
                        if (deshabilitar !== undefined) {
                            btnDeshabilitar = deshabilitar.checked;
                        }
                        const formulario = acciones.find(e => e.value === 'btn_formulario');
                        if (formulario !== undefined) {
                            btnFormulario = formulario.checked;
                        }
                        const alertas = acciones.find(e => e.value === 'btn_alertas');
                        if (alertas !== undefined) {
                            btnAlertas = alertas.checked;
                        }
                        const nuevo = acciones.find(e => e.value === 'btn_nuevo');
                        if (nuevo !== undefined) {
                            btnNuevo = nuevo.checked;
                        }
                        const viaje = acciones.find(e => e.value === 'btn_viaje');
                        if (viaje !== undefined) {
                            btnViaje = viaje.checked;
                        }
                    }
                }
            }
            const objModificar = {
                label: t('btn_modificar'),
                color: "green",
                onClick: (param) => editarElementoSelected(param),
            };
            const objDeshabilitar = {
                label: t('btn_deshabilitar'),
                color: "red",
                onClick: (param) => cambiarEstado(param),
            };
            const objFormulario = {
                label: t('btn_formulario'),
                color: "blue",
                onClick: (param) => goToFormularioChecklist(param),
            };
            const objAlertas = {
                label: t('btn_alertas'),
                color: "orange",
                onClick: (param) => goToAlertas(param),
            };
            const objViaje = {
                label: t('btn_viaje'),
                color: "purple",
                onClick: (param) => goToViaje(param),
            };
            for (let i = 0; i < lista.length; i++) {
                let acciones = [];
                const elemento = lista[i];
                if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                    acciones.push(objFormulario);
                    acciones.push(objModificar);
                    acciones.push(objDeshabilitar);
                    acciones.push(objAlertas);
                    setBtnNuevo(true);
                    if (elemento.viaje === TRUE) {
                        acciones.push(objViaje);
                    }
                }
                if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                    if (btnModificar === true) {
                        acciones.push(objModificar);
                    }
                    if (btnDeshabilitar === true) {
                        acciones.push(objDeshabilitar);
                    }
                    if (btnFormulario === true) {
                        acciones.push(objFormulario);
                    }
                    if (btnAlertas === true) {
                        acciones.push(objAlertas);
                    }
                    setBtnNuevo(btnNuevo);
                    if (elemento.viaje === TRUE && btnViaje === true) {
                        acciones.push(objViaje);
                    }
                }
                lista[i].acciones = acciones;
            }
            setListaElementos(lista);
        } catch (err) {
            console.log('agregarAccionesALista err');
            console.log(err);
        }
    }

    const editarElementoSelected = (data) => {
        try {
            // console.log("editarElementoSelected");
            // console.log(data);
            if (data.acciones !== undefined) {
                delete data.acciones;
            }
            let objData = {};
            objData.id = data.id;
            objData.manejoDefensivo = data.manejoDefensivo;
            sharedNextPage("checklist/preguntas-checklist", objData, history);
        } catch (err) {
            console.log("editarElementoSelected err");
            console.log(err);
        }
    };

    const goToFormularioChecklist = (data) => {
        try {
            // console.log('goToFormularioChecklist');
            // console.log(data);
            if (data.acciones !== undefined) {
                delete data.acciones;
            }
            let objData = {};
            objData.id = data.id;
            sharedNextPage("checklist/formulario-checklist", objData, history);
        } catch (err) {
            console.log("goToFormularioChecklist err");
            console.log(err);
        }
    };

    const goToAlertas = (data) => {
        try {
            // console.log('goToFormularioChecklist');
            // console.log(data);
            if (data.acciones !== undefined) {
                delete data.acciones;
            }
            let objData = {};
            objData.idChecklist = data.id;
            objData.nombre = data.nombre;
            sharedNextPage("checklist/alertas", objData, history);
        } catch (err) {
            console.log("goToAlertas err");
            console.log(err);
        }
    };

    const goToViaje = (data) => {
        try {
            // console.log('goToViaje');
            // console.log(data);
            if (data.acciones !== undefined) {
                delete data.acciones;
            }
            let objData = {};
            objData.idChecklist = data.id;
            objData.nombre = data.nombre;
            sharedNextPage("checklist/viaje-checklist", objData, history);
        } catch (err) {
            console.log("goToViaje err");
            console.log(err);
        }
    };

    const cambiarEstado = async (data) => {
        try {
            // console.log("cambiarEstado");
            // console.log(data);
            setElementoSelected(data);
            setModalConfirmarDeshabilitarVisible(true);
        } catch (err) {
            console.log("cambiarEstado err");
            console.log(err);
        }
    };

    const handleNuevoClick = () => {
        setElemento({});
        setModalCrearChecklistVisible(true);
    }

    const handleAtrasClick = () => {
        history.goBack();
    }

    const validar = () => {
        try {
            // console.log('validar');
            // console.log(elemento);
            let error = "";
            if (elemento.nombre === undefined || elemento.nombre === null || String(elemento.nombre).trim().length === 0) {
                error = error + t('alert_nombre_es_requerido') + "\n";
            }
            if (elemento.nota === undefined || elemento.nota === null) {
                elemento.nota = "";
            }
            if (String(error).length > 0) {
                alert(error);
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }

    const crearChecklist = async (tipoChecklistSelected) => {
        try {
            // console.log('crearChecklist');
            const valid = validar();
            if (valid === false) {
                return;
            }
            elemento.idTipoChecklist = tipoChecklistSelected !== null ? tipoChecklistSelected.value : null;
            // elemento.idArea = areaSelected !== null ? areaSelected.value : null;
            // elemento.idCiudad = ciudadSelected !== null ? ciudadSelected.value : null;
            // elemento.idMarcaVehiculo = marcaVehiculoSelected !== null ? marcaVehiculoSelected.value : null;
            // elemento.idTipoVehiculo = tipoVehiculoSelected !== null ? tipoVehiculoSelected.value : null;
            // elemento.idTipoCarroceria = tipoCarroceriaSelected !== null ? tipoCarroceriaSelected.value : null;
            // elemento.idTipoCombustible = tipoCombustibleSelected !== null ? tipoCombustibleSelected.value : null;
            console.log(elemento);

            const creado = await crearNuevoChecklist(elemento);
            // console.log('creado');
            // console.log(creado);
            if (creado.error === false) {
                alert(t('alert_procesado_correctamente'));
                setModalCrearChecklistVisible(false);
                let objData = {};
                objData.id = creado.id;
                sharedNextPage("checklist/preguntas-checklist", objData, history);
                // setCargandoPage(true);
                // iniciar();
            }
            if (creado.error === true) {
                alert(t('alert_no_se_pudo_procesar'))
            }
        } catch (err) {
            console.log('crearChecklist err');
            console.log(err);
        }
    }

    const cancelarCrearChecklist = () => {
        setModalCrearChecklistVisible(false);
    }

    const handleInputChange = (event) => {
        // console.log('handleInputChange');
        const { name, value } = event.target;
        // console.log(name);
        // console.log(value);
        setElemento({ ...elemento, [name]: value });
    };

    const handleCancelModal = () => {
        setModalConfirmarDeshabilitarVisible(false);
    };

    const handleConfirmModal = async () => {
        setModalConfirmarDeshabilitarVisible(false);
        if (elementoSelected == null) {
            return;
        }
        let objEnviar = {};
        objEnviar.id = elementoSelected.id;
        if (elementoSelected.id !== 0) {
            // console.log('crear correo');
            let deshabilitado = await deshabilitarChecklist(objEnviar);
            // console.log('creado');
            // console.log(creado);
            if (deshabilitado === true) {
                alert(t('alert_procesado_correctamente'));
                reset();
            }
            if (deshabilitado === false) {
                alert(t('alert_no_se_pudo_procesar'));
            }
        }
    };

    const reset = async () => {
        setCargandoPage(true);
        iniciar();
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return SinAccesoCard();
            }
            return (
                <div>
                    <div className="pt-4 px-4 flex justify-between">
                        <div className="flex justify-center align-center">
                            <label
                                style={{
                                    paddingLeft: 10,
                                    fontWeight: 'bold',
                                }}
                            >
                                {t('titulo_gestionar_mis_checklist')}
                            </label>
                        </div>
                        <div className="flex justify-center">
                            {btnNuevo === true && (
                                <button
                                    type="button"
                                    className={ESTILO_BOTON_LISTAR_NUEVO}
                                    onClick={handleNuevoClick}
                                    style={{ backgroundColor: colorMain }}
                                >
                                    {t('btn_nuevo')}
                                </button>
                            )}
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                            >
                                {t('btn_atras')}
                            </button>
                            {/* <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                            >
                                <Settings />
                            </button> */}
                        </div>
                    </div>
                    <Grid rows={listaElementos} headers={headers} />
                    <ModalConfirmar
                        isOpen={modalConfirmarDeshabilitarVisible}
                        onCancel={handleCancelModal}
                        onConfirm={handleConfirmModal}
                        message={t('alert_esta_seguro_de_deshabilitar_checklist')}
                    />
                    <ModalCrearChecklist
                        isOpen={modalCrearChecklistVisible}
                        onCancel={cancelarCrearChecklist}
                        onConfirm={crearChecklist}
                        elemento={elemento}
                        handleInputChange={handleInputChange}
                    />
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}